<template>
  <div class="admin-content">
    <div class="ticket-main">
      <div class="ticket_top">
        <el-form @submit.native.prevent>
          <el-form-item label="取票号：">
            <el-input id="input" class="ticket_input" autofocus v-model="content" placeholder="请输入取票号或扫描取票码" @keyup.native.enter.prevent="onSearch">
              <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <p v-show="isInspect" class="tips" style="color:#c0c0c0">*请用户出示订单详情页扫码入场</p>
      </div>
      <div v-show="!isInspect" class="ticket_down">
        <div class="ticket_detail">
          <table style="width:100%;height:100%">
            <tr>
              <td class="td_name">取票号：</td>
              <td class="td_value">{{ticket.tradeId}}</td>
            </tr>
            <tr>
              <td class="td_name">有效期至：</td>
              <td class="red_td">{{formatEndTime(ticket.endTime)}}</td>
            </tr>
            <tr>
              <td class="td_name">商品名称：</td>
              <td class="red_td">{{ticket.itemName}}</td>
            </tr>
            <tr>
              <td class="td_name">数量：</td>
              <td class="red_td">{{ticket.itemCount}}</td>
            </tr>
            <tr>
              <td class="td_name">商品金额：</td>
              <td class="td_value">{{ticket.goodAmount}}</td>
            </tr>
            <tr>
              <td class="td_name">实付：</td>
              <td class="td_value">{{ticket.payAmount}}</td>
            </tr>
            <tr>
              <td class="td_name">订单状态：</td>
              <td class="td_value">{{formatTradeState(ticket.tradeState)}}</td>
            </tr>
            <tr>
              <td class="td_name">购买时间：</td>
              <td class="td_value">{{ticket.tradeCompleteTime | formatDateTimeYear}}</td>
            </tr>
            <tr>
              <td class="td_name">使用状态：</td>
              <td class="red_td">{{formatTicketIsUse(ticket.ticketIsUse)}}</td>
            </tr>
            <tr>
              <td class="td_name">核验时间：</td>
              <td class="td_value">{{ticket.ticketUseTime | formatDateTimeYear}}</td>
            </tr>
          </table>
        </div>
        <div class="div_down">
          <el-form @submit.native.prevent>
            <el-form-item label="操作：">
              <div style="display:flex;">
                <div>
                  <el-button type="info" :disabled="isRefund" @click="refund">{{refundContent}}</el-button>
                </div>
                <div style="flex:1;text-align:right;">
                  <el-button type="primary" @click="onSkip">跳过</el-button>
                  <el-button type="danger" :disabled="isUse" @click="onSubmit">{{useContent}}</el-button>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import '@/assets/css/ticket.css'
// 接口
import { getTicketOrder, useTicket, orderRefund } from '@/api/admin'
export default {
  data() {
    return {
      content: null,
      ticket: {
        id: null,
        tradeId: null,
        itemName: null,
        itemCount: null,
        goodAmount: null,
        payAmount: null,
        tradeState: null,
        tradeCompleteTime: null,
        ticketUseTime: null,
        endTime: null,
        ticketIsUse: null
      },
      isInspect: true,
      isUse: null,
      useContent: '确认使用',
      refundContent: '退款',
      isRefund: false
    }
  },
  methods: {
    onSearch() {
      if (this.content != null) {
        this.loading = true
        // 请求接口
        getTicketOrder({ tradeId: this.content })
          .then(response => {
            if (response.data.tickets != null) {
              this.isRefund = false
              this.refundContent = '退款'
              this.ticket.id = response.data.tickets[0].id
              this.ticket.tradeId = response.data.tickets[0].tradeId
              this.ticket.endTime = response.data.order.tradeInfo.ticketEndTime
              this.ticket.itemName =
                response.data.order.tradeItemList[0].itemName
              this.ticket.itemCount =
                response.data.order.tradeItemList[0].itemCount
              this.ticket.goodAmount = response.data.order.tradeInfo.goodAmount
              this.ticket.payAmount = response.data.order.tradeInfo.payAmount
              this.ticket.tradeState = response.data.order.tradeInfo.tradeState
              this.ticket.tradeCompleteTime =
                response.data.order.tradeInfo.tradeCompleteTime
              this.ticket.ticketUseTime =
                response.data.order.tradeInfo.ticketUseTime
              this.ticket.ticketIsUse =
                response.data.order.tradeInfo.ticketIsUse
              this.isInspect = false
              if (this.ticket.ticketIsUse === 1) {
                this.isUse = true
                this.useContent = '已使用'
                this.isRefund = true
              } else {
                this.isUse = false
                this.useContent = '确认使用'
              }
            } else {
              this.$message({
                message: '取票号错误',
                type: 'warning'
              })
            }
            this.loading = false
            this.content = null
          })
          .catch(response => {
            if (response.code === 100001 && response.message == null) {
              this.$message({
                message: '取票号不正确或当前网络异常，请核实后再试',
                type: 'warning'
              })
            }
            this.content = null
            this.isInspect = true
            this.loading = false
          })
      }
    },
    onSubmit() {
      this.$confirm('此操作将使用该取票号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (this.ticket.tradeState != null) {
            this.loading = true
            // 请求接口
            useTicket({ tradeId: this.ticket.tradeId })
              .then(response => {
                if (response.data.tickets != null) {
                  this.ticket.ticketIsUse =
                    response.data.order.tradeInfo.ticketIsUse
                  if (this.ticket.ticketIsUse === 1) {
                    this.isUse = true
                    this.ticket.ticketUseTime =
                      response.data.data.order.tradeInfo.ticketUseTime
                    this.$message({
                      message: '使用成功',
                      type: 'success'
                    })
                    this.useContent = '已使用'
                  } else {
                    this.isUse = false
                    this.useContent = '确认使用'
                  }
                }
                this.loading = false
              })
              .catch(() => {
                this.loading = false
              })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消使用'
          })
        })
    },
    onSkip() {
      this.isInspect = true
      this.content = null
    },
    formatTradeState(tradeState) {
      if (tradeState === 'SUCCESS') {
        return '已支付'
      } else {
        return '未支付'
      }
    },
    formatTicketIsUse(ticketIsUse) {
      if (ticketIsUse === 0) {
        return '未使用'
      } else {
        return '已使用'
      }
    },
    formatEndTime(endTime) {
      var iDays = parseInt(
        (new Date(endTime) - new Date()) / 1000 / 60 / 60 / 24
      )
      if (iDays >= 0) {
        if (this.ticket.ticketIsUse === 1) {
          this.useContent = '已使用'
        } else {
          this.useContent = '确认使用'
        }
        return '有效票，' + iDays + '天后过期'
      } else {
        if (this.ticket.ticketIsUse === 1) {
          this.useContent = '已使用'
        } else {
          this.useContent = '已过期'
        }
        this.isUse = true
        return '无效票'
      }
    },
    onblurFocus() {
      document.getElementById('input').focus()
    },
    // 退款
    refund() {
      var confirmText = '是否确认退款?'
      if (this.ticket.ticketIsUse === 1) {
        return
      }
      this.$confirm(confirmText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 请求接口
          orderRefund({ tradeId: this.ticket.tradeId })
            .then(response => {
              this.refundContent = '已退款'
              this.isRefund = true
              this.isUse = true
              this.$message({
                type: 'success',
                message: '退款成功!'
              })
            })
            .catch(() => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退款'
          })
        })
    }
  },
  mounted() {
    window.onkeydown = this.onblurFocus
  }
}
</script>
